import React, { useContext } from 'react'
import { Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faUser, 
    faUserSlash, 
} 
from '@fortawesome/free-solid-svg-icons'
import { Doughnut } from 'react-chartjs-2';
import { LanguageContext } from '../Language/LanguageContext'

export default function UserActivity(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.home
    const isLoading = props.isLoading || false
    const activeUser = props.active
    const inActiveuser = props.inactive

    const data = {
        labels: [lang.active, lang.in_active],
        datasets: [
          {
            label: 'User activity',
            backgroundColor: ["#00275e", "lightgray"],
            data: [activeUser, inActiveuser]
          }
        ]
      };

    return(
        <div className="user-activity-section section">
            { isLoading ?
            <div className="loading-section">
                <Spinner 
                variant="primary" 
                animation="border"
                size="sm"
                />
            </div> : null
            }
            <div className="section-title">{lang.user_activity}</div>
            <div className="chart-container">
                <Doughnut data={data} options={{ maintainAspectRatio: false }}/>
            </div>
            <div className="chart-detail">
                <div className="item">
                    <div className="number">{activeUser}</div>
                    <div className="title">
                        <FontAwesomeIcon icon={faUser} style={{marginRight: 5}}/>
                        {lang.active}
                    </div>
                </div>
                <div className="item">
                    <div className="number">{inActiveuser}</div>
                    <div className="title">
                        <FontAwesomeIcon icon={faUserSlash} style={{marginRight: 5}}/>
                        {lang.in_active}
                    </div>
                </div>
            </div>
        </div>
    )
}
